.dateRangePicker {
    position: relative;
    font-family: inherit;
    z-index: 1;
}

/* Date Range Picker Trigger */
.triggerButton {
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: 0.3rem;
    padding: 0;
}

.triggerButton:hover {
    cursor: pointer;
    opacity: 0.8;
}

.triggerButtonText {
    color: var(--static-text-strong);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    flex-shrink: 0;
}

.triggerButton svg {
    width: 0.6875rem;
    height: 0.6875rem;
    flex-shrink: 0;
    color: var(--static-text-strong);
}

/* Date Range Picker Content */
.content {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: start;
    margin: 0.3rem 0 0 0;
    gap: 0.3rem;
    padding: 0;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 2;
    max-width: min-content;
}

/* Date Range Picker Presets */
.presets {
    border-radius: 0.75rem;
    border: 1px solid var(--static-divider-standard);
    background: var(--static-background-standard);
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.10), 0px 2px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
}

.presetsList {
    margin: 0;
    list-style: none;
    display: flex;
    width: 10.375rem;
    min-width: 6rem;
    padding: 0.25rem;
    flex-direction: column;
    gap: 0.25rem;
}

.presetsListItem {
    display: flex;
    margin: 0;
    padding: 0;
}

.presetButton {
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    display: flex;
    flex-grow: 1;
    padding: 0.375rem 0.5rem;
    border-radius: 0.5rem;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    background: var(--static-background-standard);
    transition: background 300ms;
    font-family: inherit;
    color: var(--static-text-standard);
}

.presetButton:hover {
    cursor: pointer;
    background: var(--selectable-hover);
}

.presetButton:active {
    /* @TODO @NICK @ACTIVE */
}

.presetButtonSelected {
    composes: presetButton;
    background: var(--selectable-selected);
}

.presetButtonSelected svg {
    color: var(--primary-enabled);
}

.presetButtonText {
    font-size: var(--fs-small);
    line-height: 1.25rem;
    font-weight: 500;
    flex-shrink: 0;
}

/* Date Range Calendar */
.calendar {
    border-radius: 0.75rem;
    border: 1px solid var(--static-divider-standard);
    background: var(--static-background-standard);
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.10), 0px 2px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 0 18.75rem;
    gap: 0.75rem;
    padding: 1rem;
}

.leftCalendar {
    transform: translateX(calc(-100% - 10.375rem - 0.75rem));
}

.calendarDescription {
    text-align: center;
    color: var(--static-text-weak);
    font-size: var(--fs-small);
    font-style: normal;
    font-weight: normal;
    line-height: 1rem;
}

.calendar :global(.react-calendar) {
    width: 100%;
    line-height: 1.125em;
}

.calendar :global(.react-calendar--doubleView) {
    width: 66rem;
}

.calendar :global(.react-calendar--doubleView .react-calendar__viewContainer) {
    display: flex;
    margin: -0.5em;
}

.calendar :global(.react-calendar--doubleView .react-calendar__viewContainer>*) {
    width: 50%;
    margin: 0.5em;
}

.calendar :global(.react-calendar),
.calendar :global(.react-calendar *),
.calendar :global(.react-calendar *:before),
.calendar :global(.react-calendar *:after) {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    transition: all 300ms;
    color: var(--static-text-standard);
}

.calendar :global(.react-calendar button) {
    margin: 0;
    border: 0;
    outline: none;
}

.calendar :global(.react-calendar button:enabled:hover) {
    cursor: pointer;
}

.calendar :global(.react-calendar__navigation) {
    display: flex;
    height: 2.5em;
    margin-bottom: 0.75em;
}

.calendar :global(.react-calendar__navigation button) {
    min-width: 2.5rem;
    background: none;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
    border-radius: 1.25rem;
}

.calendar :global(.react-calendar__navigation button:disabled) {
    filter: grayscale(100%);
    opacity: 0.5;
    cursor: not-allowed;
}

.calendar :global(.react-calendar__navigation button:enabled:hover),
.calendar :global(.react-calendar__navigation button:enabled:focus) {
    background-color: var(--secondary-hover);

}

.calendar :global(.react-calendar__month-view__weekdays) {
    text-align: center;
    text-transform: uppercase;
    font: inherit;
    font-size: var(--fs-small);
    font-weight: bold;
}

.calendar :global(.react-calendar__month-view__weekdays__weekday) {
    padding: 0;
    margin: 0;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.calendar :global(.react-calendar__month-view__weekdays__weekday abbr) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--static-text-weak);
    font-size: var(--fs-small);
    text-decoration: none;
    font-weight: normal;
}

.calendar :global(.react-calendar__month-view__weekNumbers .react-calendar__tile) {
    display: flex;
    align-items: center;
    justify-content: center;
    font: inherit;
    font-size: var(--fs-small);
    font-weight: normal;
}

.calendar :global(.react-calendar__month-view__days__day--weekend) {
    /*color: #d10000;*/
}

.calendar :global(.react-calendar__month-view__days__day--neighboringMonth),
.calendar :global(.react-calendar__decade-view__years__year--neighboringDecade),
.calendar :global(.react-calendar__century-view__decades__decade--neighboringCentury) {
    color: var(--static-text-weak);
}

.calendar :global(.react-calendar__year-view .react-calendar__tile),
.calendar :global(.react-calendar__decade-view .react-calendar__tile),
.calendar :global(.react-calendar__century-view .react-calendar__tile) {
    /* padding: 2em 0.5em; */
}

.calendar :global(.react-calendar__tile) {
    max-width: 100%;
    padding: 1px 0;
    background: none;
    text-align: center;
    font: inherit;
    font-size: 1rem;
    height: 2.5rem;
    display: flex;
    align-items: stretch;
    justify-content: center;
}

.calendar :global(.react-calendar__tile abbr) {
    border-radius: 1.25rem;
    border: 1px solid transparent;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.calendar :global(.react-calendar__tile:disabled abbr) {
    background-color: transparent;
    color: var(--interactive-fill-secondary-ondisabled);
}

.calendar :global(.react-calendar__month-view__days__day--neighboringMonth:disabled),
.calendar :global(.react-calendar__decade-view__years__year--neighboringDecade:disabled),
.calendar :global(.react-calendar__century-view__decades__decade--neighboringCentury:disabled) {
    filter: grayscale(100%);
    opacity: 0.5;
    cursor: not-allowed;
}

.calendar :global(.react-calendar__tile:enabled:hover abbr),
.calendar :global(.react-calendar__tile:enabled:focus abbr) {
    background: var(--secondary-hover);
}

.calendar :global(.react-calendar__tile--now abbr) {
    color: var(--primary-enabled);
    border-color: var(--primary-enabled);
    font-weight: 500;
}

.calendar :global(.react-calendar__tile--now:enabled:hover abbr),
.calendar :global(.react-calendar__tile--now:enabled:focus abbr) {
    color: var(--primary-enabled-text);
    background-color: var(--secondary-hover);
    border-color: var(--selectable-selected);
}

.calendar :global(.react-calendar__tile--hasActive abbr) {
    background: var(--primary-enabled);
    border-color: var(--primary-enabled);
    font-weight: 500;
}

.calendar :global(.react-calendar__tile--hasActive:enabled:hover abbr),
.calendar :global(.react-calendar__tile--hasActive:enabled:focus abbr) {
    color: var(--primary-enabled-text);
    background: var(--primary-hover);
    border-color: var(--primary-enabled);
}

.calendar :global(.react-calendar__tile--active) {
    background: var(--selectable-selected);
}

.calendar :global(.react-calendar__tile--active abbr) {}

.calendar :global(.react-calendar__tile--active:enabled:hover abbr),
.calendar :global(.react-calendar__tile--active:enabled:focus abbr) {
    /* @TOOD(nick) this seems unused? */
}

.calendar :global(.react-calendar__tile--rangeStart),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverStart) {
    background: linear-gradient(90deg, transparent 50%, var(--selectable-selected) 50%);
}

.calendar :global(.react-calendar__tile--rangeEnd),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverEnd) {
    background: linear-gradient(90deg, var(--selectable-selected) 50%, transparent 50%);
}

.calendar :global(.react-calendar__tile--rangeEnd abbr),
.calendar :global(.react-calendar__tile--rangeStart abbr),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverStart abbr),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverEnd abbr) {
    background: var(--primary-enabled);
    border-color: var(--primary-enabled);
    font-weight: 500;
}

.calendar :global(.react-calendar__tile--rangeStart:enabled:hover abbr),
.calendar :global(.react-calendar__tile--rangeStart:enabled:focus abbr),
.calendar :global(.react-calendar__tile--rangeEnd:enabled:hover abbr),
.calendar :global(.react-calendar__tile--rangeEnd:enabled:focus abbr),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverStart:enabled:hover abbr),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverStart:enabled:focus abbr),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverEnd:enabled:hover abbr),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverEnd:enabled:focus abbr) {
    background: var(--primary-hover);
    border-color: var(--selectable-hover);
}


.calendar :global(.react-calendar__tile--rangeBothEnds),
.calendar :global(.react-calendar__tile--hover.react-calendar__tile--hoverBothEnds) {
    background: transparent;
}

.calendar :global(.react-calendar__tile--hover) {
    background: var(--selectable-hover);
}

.button {
    height: 100%;
    background-color: var(--static-background-strong) !important;
    padding: 0 12px !important;
}

.button:focus {
    border-color: var(--primary-enabled);
    outline: none;
}

.fullWidth {
    width: 100%;
}
